export var MessageClassification;
(function (MessageClassification) {
    MessageClassification["VALID"] = "valid";
    MessageClassification["OUT_OF_SCOPE"] = "out_of_scope";
    MessageClassification["SYSTEM"] = "system";
    MessageClassification["FEEDBACK_OR_BUG"] = "feedback_or_bug";
})(MessageClassification || (MessageClassification = {}));
//# sourceMappingURL=metadata.js.map